import { Action } from 'typescript-fsa';

import { createReducer } from '@topconagriculture/frontend-utils';
import { WidgetDTO } from '@topconagriculture/dashboard/build/api/widget/widget.types';

import { fetchWidgets, setDashboardExclamation } from './dashboard.actions';

export type DashboardState = { exclamation: boolean; widgets: WidgetDTO[] };

const initialState: DashboardState = { exclamation: false, widgets: [] };

const dashboardReducer = createReducer(initialState, {
  [setDashboardExclamation.type]: (state: DashboardState, action: Action<boolean>) => {
    return { ...state, exclamation: action.payload };
  },
  [fetchWidgets.done.type]: (state: DashboardState, action: Action<{ result: WidgetDTO[] }>) => {
    return { ...state, widgets: action.payload.result };
  },
});

export default dashboardReducer;
